import React, {useEffect,useState} from 'react';
import './index.css';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
// import favoriteIcon from './icons/favorite.png';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import pharmacyAvatar from '../pharmacies/icons/pharmacyAvatar.jpg';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from "axios";
import { getToken } from "../../auth/authenticate";
import { CircularProgress } from "@mui/material";
import PaginationComponent from 'components/common/pagination/PaginationComponent';
import { api } from 'services/ApiService';
import { PHARMACY_ORDER_STATUS } from 'constants/constants';

export const Orders = () => {
  const [filterOrders, setFilterOrders] = React.useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [limit, setLimit] = React.useState(10);
  const [offset, setOffset] = React.useState(0);

  const handleChange = (value) => {
    setPage(value);
    if (value - 1 > 0) {
      setOffset((value - 1) * limit);
    } else {
      setOffset(0);
    }
  };

  const handleSelectChange = (event) => {
    setOffset(0);
    setPage(1);
    setFilterOrders(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {

      const obj = {
        offset: offset,
        limit: limit,
        status: filterOrders === "" || filterOrders === 'ALL' ? null : filterOrders,
      };

      
      const result = await api(
        `${process.env.REACT_APP_BACKEND_URL}pharmacy-order/patient`,
        "GET",
        obj
      );
      setOrders(result?.data?.data || []);
      setPageCount(Math.ceil(result?.data?.dataCount / limit));
      setLoading(false);
    };
    fetchData();
  }, [page, filterOrders]);

  if (loading) {
    return (
      <center style={{ marginTop: 200 }}>
        <CircularProgress />
      </center>
    );
  }

  return (
    <div className="pharmaciesMain">
      <Grid container>
        <Grid item xs={6} md={6} lg={8}>
          <div className="pharmaciesMainHeading">
            <h3>Orders</h3>
          </div>
        </Grid>
        <Grid item xs={6} md={6} lg={4}>
          <Box sx={{ minWidth: 120 }} className="filterOrders">
            <FormControl fullWidth>
              <InputLabel id="filter-appointments-label">Orders</InputLabel>
              <Select
                labelId="filter-appointments-label"
                id="demo-simple-select"
                value={filterOrders}
                label="Orders"
                onChange={handleSelectChange}
              >
                <MenuItem value={"ALL"}>All</MenuItem>
                <MenuItem value={PHARMACY_ORDER_STATUS.ACCEPTED}>
                  Accepted
                </MenuItem>
                <MenuItem value={PHARMACY_ORDER_STATUS.PENDING}>
                  Pending
                </MenuItem>
                <MenuItem value={PHARMACY_ORDER_STATUS.DELIVERED}>
                  Delivered
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: "100%",
            height: "auto",
          },
        }}
      >
        <div className="scroll">
          {orders?.map((item, index) => {
            return (
              <Link
                to={`order-details/${item.pharmacyOrderId}`}
                className="paymentHistoryLink"
              >
                <div key={index}>
                  <Paper elevation={1} className="pharmaciesData">
                    <Grid container className="pharmaciesMainGrid">
                      <Grid item xs={12} md={7} lg={8}>
                        <div className="pharmacyAvatar">
                          <Stack direction="row" spacing={1}>
                            <Avatar
                              alt="Patient Avatar"
                              src={item?.Pharmacy?.User?.profileImagePath  || pharmacyAvatar}
                              variant="rounded"
                            />
                            <div className="pharmacyName">
                              <h5>{item?.Pharmacy?.businessName}</h5>
                              {item?.status === "ACCEPTED" ? (
                                <p>Order Accepted</p>
                              ) : item?.status === "PROCESSING" ? (
                                <p>Order Processing</p>
                              ) : item?.status === "PENDING" ? (
                                <p>Pending</p>
                              ) : (
                                <p>Order Delivered</p>
                              )}
                            </div>
                          </Stack>
                        </div>
                      </Grid>
                      <Grid item xs={6} md={3} lg={2}>
                        <div className="orderAppName">
                          {/* <p>Appointment Name</p> */}
                          {/* <h5>{pharmacy.app_name}</h5> */}
                        </div>
                      </Grid>
                      <Grid item xs={6} md={2} lg={2}>
                        <div className="orderAppName">
                          <p>Total Prescription</p>
                          <h5>{item.prescriptions.length} Prescription</h5>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </div>
              </Link>
            );
          })}
          {orders?.length === 0 && (
            <h4 style={{ textAlign: "center", marginTop: "100px" }}>
              No Items Found...
            </h4>
          )}
        </div>
        {/* Pagination */}
        {orders?.length !== 0 && (
          <PaginationComponent
            count={pageCount}
            page={page}
            onChangeItem={handleChange}
          />
        )}
      </Box>
    </div>
  );
}